import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import Loader from '../components/common/Loader.jsx';

// Pass `allowed` as an array of role strings, e.g. ['admin'] or ['admin', 'marketer'].
export default function RoleBasedRoute({ allowed = [], children }) {
  const { isAuthenticated, role, loading } = useAuth();

  if (loading) return <Loader fullScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!allowed.includes(role)) return <Navigate to="/" replace />;

  return children;
}
